import React from "react";
import { Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import Features from "@/pages/Features";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import Legal from "@/pages/Legal";
import ShareLogo from "@/pages/ShareLogo";
import SharedKit from "@/pages/SharedKit";
import SiteView from "@/pages/SiteView";

/**
 * Public, unauthenticated routes (landing, marketing, public share pages).
 */
export const PublicRoutes = (
  <>
    <Route path="/" element={<Landing />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/pricing" element={<Pricing />} />
    <Route path="/features" element={<Features />} />
    <Route path="/how-it-works" element={<HowItWorks />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/legal/:slug" element={<Legal />} />
    <Route path="/share/logo/:slug" element={<ShareLogo />} />
    <Route path="/share/kit/:id" element={<SharedKit />} />
    <Route path="/s/:slug" element={<SiteView />} />
  </>
);
